import React from "react";
const Footer = () => (
  <footer className="bg-light p-3 text-rig">
    <div>
      <p>
        Made with <span className="mate">&#129481;</span> by{" "}
        <a target="_blank" rel="noopener noreferrer" href="https://kinzbio.com">
          Kinzbio
        </a>
      </p>
    </div>
  </footer>
);

export default Footer;
